import { type SxProps, type Theme } from "@mui/material/styles";

export const PAGE_SX: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
  pt: 1.5,
  pl: 1.5,
  pr: 2.5,
  pb: 2.5,
  backgroundColor: theme.palette.background.default,
});

export const CARD_SX: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
  gap: 1.5,
  p: 1.5,
  border: 1,
  borderColor: theme.palette.divider,
  borderRadius: 1,
  backgroundColor: theme.palette.background.paper,
});

export const HEADER_SX: SxProps<Theme> = { display: "flex", flexDirection: "column", gap: 1 };

export const HEADER_ROW_SX: SxProps<Theme> = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: 1.5,
};

export const ACTIONS_SX: SxProps<Theme> = { display: "flex", alignItems: "center", gap: 1.5 };

export const CONTENT_SX: SxProps<Theme> = { flex: 1, minHeight: 0, overflowY: "auto" };
